import React, { useEffect, useState, useRef } from 'react'
import { useViewport } from 'utils'

// resources
import CloseIcon from 'assets/icons/close-white-black-15x15.svg?component'
import CategoryList from 'assets/json/popular-category.json'
import ArrowLeftIcon from 'assets/icons/arrow-left-12x21.svg?component'
import ArrowRightIcon from 'assets/icons/arrow-right-12x21.svg?component'

// styles
import styles from './index.module.scss'
import router from 'next/router'

const CategorySelection = ({ open, onClose }) => {
  const viewport = useViewport()

  const [show, setShow] = useState(false)
  const [categoryList, setCategoryList] = useState<any[]>([])
  const leftSectionRef = useRef<HTMLDivElement>(null)
  // Drag-to-scroll state
  const isDragging = useRef(false)
  const startX = useRef(0)
  const scrollLeft = useRef(0)
  const animationFrame = useRef<number | null>(null)
  const lastWalk = useRef(0)

  // Scroll handlers
  const handleScrollLeft = () => {
    if (leftSectionRef.current) {
      leftSectionRef.current.scrollBy({ left: -200, behavior: 'smooth' })
    }
  }
  const handleScrollRight = () => {
    if (leftSectionRef.current) {
      leftSectionRef.current.scrollBy({ left: 200, behavior: 'smooth' })
    }
  }

  // Mouse event handlers for drag-to-scroll
  const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
    isDragging.current = true
    startX.current = e.pageX - (leftSectionRef.current?.offsetLeft || 0)
    scrollLeft.current = leftSectionRef.current?.scrollLeft || 0
    lastWalk.current = 0
    document.body.style.userSelect = 'none'
    if (leftSectionRef.current) {
      leftSectionRef.current.style.cursor = 'grabbing'
    }
  }
  const handleMouseLeave = () => {
    isDragging.current = false
    document.body.style.userSelect = ''
    if (leftSectionRef.current) {
      leftSectionRef.current.style.cursor = ''
    }
    if (animationFrame.current) {
      cancelAnimationFrame(animationFrame.current)
    }
  }
  const handleMouseUp = () => {
    isDragging.current = false
    document.body.style.userSelect = ''
    if (leftSectionRef.current) {
      leftSectionRef.current.style.cursor = ''
    }
    if (animationFrame.current) {
      cancelAnimationFrame(animationFrame.current)
    }
  }
  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!isDragging.current || !leftSectionRef.current) return
    const x = e.pageX - leftSectionRef.current.offsetLeft
    const walk = x - startX.current
    lastWalk.current = walk
    if (animationFrame.current) {
      cancelAnimationFrame(animationFrame.current)
    }
    animationFrame.current = requestAnimationFrame(() => {
      if (leftSectionRef.current) {
        leftSectionRef.current.scrollLeft = scrollLeft.current - lastWalk.current
      }
    })
  }

  useEffect(() => {
    let array: any[] = []
    array.push({
      id: 0,
      name: 'All',
      query: 'all',
      checked: true,
    })

    CategoryList.map(item => {
      let object: any = item
      object.checked = false
      array.push(object)
    })
    setCategoryList(array)
  }, [])

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        setShow(true)
      }, 100)
    }
  }, [open])

  const handleCategoryClick = (item: any) => {
    if (item.query === 'all') router.push('/')
    else router.push(`/category/${item.query.replaceAll(' ', '%20')}`)
    onClose()
  }

  return (
    <div className="w-full h-[100px] relative mt-[60px] lg:mt-0">
      <div className={`g-container ${styles.modalView} ${show ? styles.show : styles.hide}`}>
        <div
          className={styles.leftSection}
          ref={leftSectionRef}
          // onMouseDown={handleMouseDown}
          // onMouseLeave={handleMouseLeave}
          // onMouseUp={handleMouseUp}
          // onMouseMove={handleMouseMove}
        >
          {categoryList.map((item, index) => (
            <div
              key={index}
              className={item.checked ? styles.activeButton : styles.inactiveButton}
              onClick={() => handleCategoryClick(item)}
            >
              {item.name}
            </div>
          ))}
        </div>
        {viewport === 'ls' || viewport === 'xl' || viewport === '2xl' ? (
          <div className={styles.rightSection}>
            <div className="w-[45px] h-[43px]"></div>
            <div className="w-[90px] h-[43px] flex gap-[5px]">
              <div className={styles.arrowButton} onClick={handleScrollLeft}>
                <ArrowLeftIcon />
              </div>
              <div className={styles.arrowButton} onClick={handleScrollRight}>
                <ArrowRightIcon />
              </div>
            </div>
            <div className={styles.closeIcon} onClick={onClose}>
              <CloseIcon alt="" />
            </div>
          </div>
        ) : (
          <div className={styles.rightSectionMobile}>
            <div className={styles.closeIcon} onClick={onClose}>
              <CloseIcon alt="" />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default CategorySelection
